import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal";
import get from "lodash/get";

class CancelAccount extends React.Component {
  render(ctx) {
    const { activeUser, momentTZ, activeUserToRequest } = this.context.locals;
    return (
      <form method="POST" action="/actions/user/cancel-account">
        <Modal width="600px">
          <div className="head">
            <h2 className="alt">Cancel Subscription</h2>
          </div>

          <div className="body">
            <p>
              <b>
                {activeUser.name}, are you sure you want to cancel your
                subscription?
              </b>{" "}
              We will be sad to see you go! If there is anything we can do to
              change your mind please{" "}
              <a href="/dashboard/support/contact">get in touch</a>!
            </p>

            <p>
              If you are set on cancelling your subscription please enter your
              password below, then click 'cancel subscription'. Your
              subscription will be active until the end of the billing period (
              {momentTZ(get(activeUserToRequest, "stripe.period_end")).format(
                "MMM. DD, YYYY"
              )}
              ), after which point it will be disabled. If you decide to change
              your mind, at any time you can reactivate your account by logging
              in and re-subscribing.
            </p>

            <p>
              If after 60 days you have not re-subscribed in your account data
              will be permanently deleted.
            </p>
            <p>
              <input
                type="password"
                placeholder="Enter your password to confirm"
                className="text-input"
                name="password"
              />
            </p>
          </div>

          <div className="foot">
            <button className="button-input full" type="submit">
              Cancel Subscription
            </button>
          </div>
        </Modal>
      </form>
    );
  }
}

CancelAccount.contextTypes = { locals: PropTypes.object };

export default CancelAccount;
